var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.getTo()}},[_vm._v(" "+_vm._s(this.getToLabel())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }